export const variables = {
  availableErrorStatuses: ['404', '500', '504'],
};

export const LANGUAGES = [
  { code: 'da', localName: 'Dansk' },
  { code: 'de', localName: 'Deutsch' },
  { code: 'el', localName: 'Ελληνικά' },
  { code: 'en', localName: 'English' },
  { code: 'es', localName: 'Español' },
  { code: 'fr', localName: 'Français' },
  { code: 'it', localName: 'Italiano' },
  { code: 'lv', localName: 'Latviešu' },
  { code: 'nl', localName: 'Nederlands' },
  { code: 'no', localName: 'Norsk' },
  { code: 'pl', localName: 'Polski' },
  { code: 'pt', localName: 'Português' },
  { code: 'se', localName: 'Svenska' },
];
